import { render, staticRenderFns } from "./Voyage.vue?vue&type=template&id=d37ed0f4&scoped=true"
import script from "./Voyage.vue?vue&type=script&lang=js"
export * from "./Voyage.vue?vue&type=script&lang=js"
import style0 from "./Voyage.vue?vue&type=style&index=0&id=d37ed0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.44.2__css-load_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37ed0f4",
  null
  
)

export default component.exports